import { ChangeEvent, KeyboardEvent, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { Input } from '@/components/ui/input';

import { cn } from '@/lib/utils';

const PLUS_SYMBOL = '+';
const ENTER_KEY = 'Enter';

export const ClientQuickSearchForm = (props: {
  companyId: number;
  className?: string;
}) => {
  const { companyId, className } = props;
  const { t } = useTranslation();

  const [clientId, setClientId] = useState('');

  const openClientPage = (id: string, isFromScanner: boolean) => {
    const formattedClientId = isFromScanner ? id.slice(0, -1) : id;
    const clientUrl = `${location.origin}/companies/${companyId}/clients/${formattedClientId}`;

    window.open(clientUrl, '_blank', 'noopener,noreferrer');
    setClientId('');
  };

  const onClientIdChange = (event: ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setClientId(value);

    // Handle scanner input (ends with +)
    if (value.endsWith(PLUS_SYMBOL)) {
      openClientPage(value, true);
    }
  };

  const onEnterPress = (event: KeyboardEvent<HTMLInputElement>) => {
    if (event.key === ENTER_KEY && clientId) {
      openClientPage(clientId, false);
    }
  };

  return (
    <Input
      className={cn(
        'border-border bg-muted text-foreground placeholder:text-muted-foreground hover:bg-muted/80 focus-visible:border-ring h-8 border px-3 text-sm font-medium shadow-none transition-colors focus-visible:ring-0 focus-visible:ring-offset-0 sm:text-base',
        className,
      )}
      onKeyDown={onEnterPress}
      value={clientId}
      onChange={onClientIdChange}
      placeholder={t('Find Client by ID')}
    />
  );
};
